<template lang="pug">
div
    button.button.is-danger.is-large(@click='clear_pin_prompt')
      font-awesome-icon(icon='sign-out-alt')
    #clear_prompt.modal
      .modal-background
      .modal-card
        .modal-card-head
          .title(style="color:black") {{clear_pin_text}}?
        .modal-card-body
          section.message.is-medium
            .message-body
              p(style="font-weight:bold") {{clear_all_data}}
              p {{reentered}} 
          button(style="margin:1rem").button.is-large.is-info(@click="close_clear_pin_prompt") {{nevermind}}
          button(style="margin:1rem").button.is-large.is-danger(@click="clear_pin") {{clear_pin_text}}
    
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ClearPin",
  props: {},
  date: function() {
    return {};
  },
  components: {},
  computed: {
    ...mapState(["language"]),
    clear_pin_text: function() {
      return "Clear Pin";
    },
    nevermind() {
      return "Nevermind";
    },
    clear_all_data() {
      return "Clear all data?";
    },
    reentered() {
      return "PIN must be re-entered to use app again.";
    }
  },
  methods: {
    clear_pin_prompt() {
      // check for active timers.
      document.getElementById("clear_prompt").classList.add("is-active");
    },
    close_clear_pin_prompt() {
      document.getElementById("clear_prompt").classList.remove("is-active");
    },

    clear_pin() {
      this.$store.commit("login", null);
      localStorage.clear();
      this.close_clear_pin_prompt();
    }
  }
};
</script>

<style scoped lang="less">
.modal-card {
  max-width: 500px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>
